/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './trimester.reducer';

export const TrimesterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const trimesterEntity = useAppSelector(state => state.trimester.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="trimesterDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.trimester.detail.title">Trimester</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.trimester.id">Id</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.id}</dd>
          <dt>
            <span id="trimesterNumber">
              <Translate contentKey="tinyMedicRestApp.trimester.trimesterNumber">Trimester Number</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.trimesterNumber}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.trimester.active">Active</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.trimester.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.trimester.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.trimester.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.trimester.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.trimester.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{trimesterEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimester.patient">Patient</Translate>
          </dt>
          <dd>{trimesterEntity.patient ? trimesterEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimester.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{trimesterEntity.pregnancy ? trimesterEntity.pregnancy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/trimester" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/trimester/${trimesterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TrimesterDetail;
